

  // get fbp
function getFbpCookie() {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
        const parts = cookies[i].split('=');
        if (parts[0] === '_fbp') {
            return decodeURIComponent(parts[1]);
        }
    }
    return null; // Return null if the _fbp cookie is not found
}



// get fbc
function getFbcCookie() {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
        const parts = cookies[i].split('=');
        if (parts[0] === '_fbc') {
            return decodeURIComponent(parts[1]);
        }
    }
    return null; // Return null if the _fbc cookie is not found
}


// get IP address 
function getUserIPDetails(apiKey) {
    return new Promise((resolve, reject) => {
        fetch(`http://api.ipstack.com/check?access_key=${apiKey}`)
            .then(response => response.json())
            .then(data => {
                resolve(data);
            })
            .catch(error => {
                reject(error);
            });
    });
}



// Function to check the scroll position and trigger prepareSubmission
function checkScrollPosition() {
  // Get the current scroll position
  const scrollPosition = window.scrollY || window.pageYOffset;

  // If the scroll position is greater than or equal to 2000px, execute prepareSubmission
  if (scrollPosition >= 2000) {
    prepareSubmission();
    // Optionally, remove the event listener after it's triggered once
    window.removeEventListener('scroll', checkScrollPosition);
  }
}

// Attach the scroll event listener to the window
window.addEventListener('scroll', checkScrollPosition);

function sendScrollToPrice(userAgent,url,fbc,fbp,ip) {
  $.ajax({
     type: "POST",
     url: "https://hook.us1.make.com/x72by9duxfkt6dbdby0ir1j5ddy5c9fv",
     data: { 
             "userAgent":userAgent,
             "url": url,
             "fbc":fbc,
             "fbp":fbp,
             "ip":ip,
           },
     complete: function(data)
     {
          console.log(data);

     }
   });
}

function prepareSubmission() {
  const fbp = getFbpCookie();
  const fbc = getFbcCookie();
  var userAgent = navigator.userAgent;
  var url = window.location.href;
  const apiKey = '4b6ecfcc2ddf9fa0b4b6eaec178905e5';
  getUserIPDetails(apiKey)
    .then(details => {
        var ip = details.ip;

        sendScrollToPrice(userAgent,url,fbc,fbp,ip);

    })
    .catch(error => {
        console.error('Error fetching IP details:', error);
    });
  
}
